import styled from 'styled-components';

export const ObtainedCertificationsWrapper = styled.div`
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(4, 1fr);
`;
